import React from 'react';
import Overview from '../Overview/Overview';
import Experience from '../Experience/Experience';
import TechnicalSkills from '../TechnicalSkills/TechnicalSkills';
import './TabContent.scss';

const TabContent = ({ activeTab }) => {
	const renderContent = () => {
		switch (activeTab) {
			case 'overview':
				return <Overview />;
			case 'experience':
				return <Experience />;
			case 'skills':
				return <TechnicalSkills />;
			default:
				return <Overview />;
		}
	};

	return <div className="tab-content">{renderContent()}</div>;
};

export default TabContent;
